import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UIChart } from 'primeng/chart';
import { ChartData, ChartDataset, ChartConfig } from '@components/svg-chart';

@Component({
  selector: 'msf-p-chart',
  templateUrl: './msf-p-chart.component.html',
  imports: [UIChart],
  styleUrls: ['./msf-p-chart.component.scss']
})
export class MsfPChartComponent {
  @Input() chartType: "line" | "bar" | "scatter" | "bubble" | "pie" | "doughnut" | "polarArea" | "radar" | undefined = 'bar';
  @Input() chartData: ChartData = { labels: [], datasets: [] };
  @Input() config: ChartConfig = {};
  @Input() isLoading: boolean = false;
  @Input() noDataMessage: string = 'No data available';
  @Input() showLegend: boolean = true;
  @Output() legendClick = new EventEmitter<string>();

  get hasData(): boolean {
    return (this.chartData && this.chartData.datasets && this.chartData.datasets.length>0);
  }

  onLegendClick(label: string) {
    this.legendClick.emit(label);
  }
}
